import { useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { ActiveFilter, ActiveFiltersBar, Input, TableFilter, TableFilters } from 'app/components'

export const LogsUsuarioListSearchComponent = () => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(
    () => (debouncedFilters.nome.trim() ? `pessoa.nome~*${debouncedFilters.nome.trim()}*` : ''),
    [debouncedFilters]
  )

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  const activeFilters: ActiveFilter[] = filters.nome.trim()
    ? [
        {
          key: 'nome',
          label: 'Usuário',
          value: `“${filters.nome.trim()}”`,
          onRemove: () => setFilter('nome', ''),
        },
      ]
    : []

  return (
    <TableFilters
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'usuário encontrado' : 'usuários encontrados'}`
          }
        />
      }
    >
      <TableFilter label='Usuário' wide>
        <Input
          placeholder='Digite o nome do usuário'
          value={filters.nome}
          onChange={(e) => setFilter('nome', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
